import { useEffect, useRef } from 'react';
import { Canvas } from 'fabric';
import { buildFabricObjectFromLayer } from './layerFactory';
import { resolveCanvasSize } from './layoutFactory';

export default function useCanvasEngine(canvasElementRef, canvasData) {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!canvasElementRef.current || !canvasData) return undefined;

    const { width, height } = resolveCanvasSize(canvasData);
    const canvas = new Canvas(canvasElementRef.current, {
      width,
      height,
      selection: false,
      preserveObjectStacking: true,
    });
    canvasRef.current = canvas;

    let cancelled = false;

    const render = async () => {
      const layers = Array.isArray(canvasData.layers) ? canvasData.layers : [];
      for (const layer of layers) {
        if (cancelled) return;
        try {
          const object = await buildFabricObjectFromLayer(layer);
          if (object) canvas.add(object);
        } catch {
          // ignore broken layer and continue rendering remaining layers
        }
      }
      canvas.requestRenderAll();
    };

    render();

    return () => {
      cancelled = true;
      canvas.dispose();
      canvasRef.current = null;
    };
  }, [canvasElementRef, canvasData]);

  return canvasRef;
}
